import { v4 as uuidv4 } from 'uuid';

/**
 * Single source of generated entity ids (pages, shapes, images, …). Routing all id
 * creation through one seam keeps reducers deterministically testable: a test can mock
 * this module to yield predictable ids
 */
export const generateId = (): string => uuidv4();
